import { UserModuleAccessCollection } from '@predictiveindex/client-permissions-lib';
import {
    AccountConfig,
    AssessmentAdministrator,
    InitData,
    UserProfile
} from '../../core-data-model';
import { InitDataService } from './InitData.service';

const javascriptInitData = {
    administrator: {
        firstName: 'firstName',
        userGuid: 'userId',
        companyId: 'companyId',
        surveyUserId: 'surveyUserId',
        apiCompanyId: 'apiCompanyId',
        apiUserId: 'apiUserId',
        company: 'company',
        createdTime: new Date('2023-04-18'),
        email: 'email',
        fullName() {
            return '';
        }
    } as AssessmentAdministrator,
    userProfile: {
        firstName: 'firstName',
        lastName: 'lastName',
        userGuid: 'userGuid',
        settings: {
            currentCompany: 'companyId'
        }
    },
    accountConfig: {
        currentApiCompanyId: 'apiCompanyId',
        piVersion: 2
    }
} as InitData;

const getMock: () => Partial<InitDataService> = () => ({
    companyEmailDomains: {
        allowList: ['@test.com', '@user.com']
    },
    javaScriptInitData: javascriptInitData,
    get user(): AssessmentAdministrator {
        return this.javaScriptInitData.administrator;
    },
    get profile(): UserProfile {
        return this.javaScriptInitData.userProfile;
    },
    get account(): AccountConfig {
        return this.javaScriptInitData.accountConfig;
    },
    hasExperimentAccess: () => true,
    getUserPermissionsCollection: () =>
        Promise.resolve({} as UserModuleAccessCollection),
    getUserAccessLevelMap: () => new Map([]),
    refreshUserPermissions: () => Promise.resolve(),
    getJavaScriptInitData: async () => javascriptInitData,
    isPI2OrgAdmin: () => true
});

export const initDataServiceMock = {
    getMock,
    provider: (Service: typeof InitDataService) => ({
        provide: Service,
        useValue: getMock()
    })
};
